<template>
  <div class="pa-list">
    <van-tabs v-model="activeName" @click="changeTab" sticky>
		  <van-tab name="resume">
		  	<div slot="title">
		  		<span class="title">
		  			人职派单
		  			<span class="dot" v-if="grabDispatchTalentUnreadCount"></span>
		  		</span>
		  	</div>
		  	<pa-resume-list></pa-resume-list>
		  </van-tab>
		  <van-tab name="position">
		  	<div slot="title">
		  		<span class="title">
			  		职位派单
			  		<span class="dot" v-if="grabDispatchPositionUnreadCount"></span>
			  	</span>
		  	</div>
		  	<position-list></position-list>
		  </van-tab>
		</van-tabs>
  </div>
</template>

<script>

import PaResumeList from '@/components/pa/paResumeList'
import PositionList from '@/components/pa/positionList'
import {getUnreadCount} from '@/api/pa'

export default {
  name: "pa-module",
  data(){
  	return {
      grabDispatchPositionUnreadCount: 0,
      grabDispatchTalentUnreadCount: 0,
  		hasResume: false,
  		hasPosition: false,
  		activeName: this.$route.query.type || 'resume'
  	}
  },
  components: {
  	PaResumeList,
  	PositionList
  },
  methods: {
  	changeTab(name){
  		this.$router.replace({name: this.$route.name, query: {type: name}});
  	},
    init(){
      getUnreadCount().then(res=>{
        if(res.data){
          this.grabDispatchTalentUnreadCount = res.data.grabDispatchTalentUnreadCount;
          this.grabDispatchPositionUnreadCount = res.data.grabDispatchPositionUnreadCount;
        }
      }).catch(res=>{})
    }
  },
  created() {
    this.init()
  }
};
</script>

<style scoped lang="scss">
  .pa-list{
    .van-tab{
      span.title{
        position: relative;
        display: inline-block;
        .dot{
          width: 8px;
          min-width: 0;
          height: 8px;
          background-color: #ee0a24;
          border-radius: 100%;
          position: absolute;
          top: 14px;
          right: -6px;
          z-index: 99;
        }
      }
    }
  }
</style>
